import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './utils/auth';
import { initSmoothScroll } from './utils/lenis';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Manifesto } from './components/Manifesto';
import { Products } from './components/Products';
import { Resellers } from './components/Resellers';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { CookieConsent } from './components/CookieConsent';
import { ProtectedRoute } from './components/ProtectedRoute';
import { mockData } from './mock';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Catalog from './pages/Catalog';

function HomePage() {
  useEffect(() => {
    const lenis = initSmoothScroll();
    return () => {
      lenis?.destroy();
    };
  }, []);

  return (
    <div className="bg-[#0a1628]">
      <Header />
      <Hero />
      <Marquee text={mockData.marqueeText} />
      <Manifesto />
      <Products />
      <Marquee text={mockData.marqueeText} />
      <Resellers />
      <Contact />
      <Footer />
      <WhatsAppButton phoneNumber="5511981919933" />
    </div>
  );
}

function App() {
  return (
    <div className="App bg-[#0a1628]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/termos" element={<Terms />} />
          <Route path="/privacidade" element={<Privacy />} />
          <Route path="/catalogo" element={<Catalog />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
